export default __webpack_public_path__ + "static/media/106.e03787f1.png";